import React, { useContext, useState } from 'react'
import Layout from '../../component/layout/Layout'
import {useParams,useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import { PasswordFiled } from '../../component/Form'
import { passwordValidation } from '../../utils/validation';
import SubmitField from '../../component/Form/SubmitField';
import { restPasswordServer } from '../../services/authService';
import { rootContexts } from '../../contexts/rootContexts';
export default function index() {
  const [serverError,setServerError]=useState("")
  const [loader,setLoader]= useState(false);
  const navigate = useNavigate();
  const { token } = useParams();
  const { setAsLogin } = useContext(rootContexts);
  if(!token){
    navigate('/')
    
  }
 
  const formik = useFormik({
    initialValues: {
     
      password: "",
      password_confirmation:"",
     
    },
    validationSchema:yup.object({
          password:passwordValidation,
          password_confirmation:passwordValidation,
    }),
    onSubmit: async (values) => {
        setLoader(true)
        
         const result = await restPasswordServer(values,token)
     
        if(result.status){
        setServerError({
          status:true,
          message:"Your password has been successfully changed."
        })
        setLoader(false);
        setAsLogin(false)
        navigate('/');
        setAsLogin(true)
        }
        else{
          setLoader(false);
          setServerError({
            status:false,
            message:result?.data?.error
          })
         
         
        }

    },
  });
  return (
    <Layout>
  <div className="py-4 h-full">
  <section className="shadow-lg dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-full lg:py-0">
         
          <div className="w-full px-2 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
            <h1 className="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white text-center">
              Reset Password
            </h1>
            {serverError.status === true || serverError.status==false ?
          <div className={`p-1 rounded ${serverError.status ? "shadow-blue-600 bg-blue-500" : "shadow-orange-600 bg-orange-400"} text-white`}>
            {serverError.message}
          </div> : null }
           
            <form onSubmit={formik.handleSubmit} className="">
                
                <PasswordFiled
                  label="Password"
                  name="password"
                  placeholder="Enter New Password"
                  formik={formik}
                 
                />
               
                <PasswordFiled
                  label="Confirm Password"
                  name="password_confirmation"
                  placeholder="Enter Confirm Password"
                  formik={formik}
                 
                />
               
                   
                <div className=" py-2">
                  <SubmitField label="Submit" loader={loader}/>
               
                </div>
              </form>
          </div>
        </div>
      </section>

  </div>
  </Layout>
  )
}
